import AddressCell from "../elements/table-view/special-cells/AddressCell";
import { ProcurementStatuses } from "../constants/contract-enums";
import $moment from "moment";
import DeliveryFailureForm from "../forms/DeliveryFailureForm";
import ScopeItemTaskForm from "../views/contracts/forms/ScopeItemTaskForm";

export function getScheduledCrewsColumns(context) {
  return [
    { label: "Crew", property: "crewIdentifier" },
    { label: "Task", property: "name" },
    {
      label: "Project & Location",
      property: "projectNameAndContractPlace",
      cellComponent: AddressCell
    },
    {
      label: "Actions",
      property: "actions",
      actions: [
        {
          label: "edit",
          clickAction: task => {
            task.scheduled_for = context
              .$moment(task.scheduled_for)
              .format("YYYY-MM-DD hh:mm:ss");
            context.$store.commit("setCreateEditComponentParams", {
              createEditComponent: ScopeItemTaskForm,
              createEditComponentData: {
                ...task,
                contract_id: task.contract.id
              },
              createEditComponentIsShown: true
            });
          }
        },
        {
          label: "View Contract",
          clickAction: task => {
            context.$router.push({
              name: "contracts-show",
              params: { id: task.contract.id }
            });
          }
        }
      ],
      additionalCellClasses: "w-px whitespace-no-wrap"
    }
  ];
}

export function getScheduledDeliveriesAndDeliveredProcurementsColumns(
  type,
  context
) {
  let columns = [
    {
      label: "PO #",
      property: "id"
    },
    {
      label: "Contract",
      property: "contractName"
    },
    {
      label: "Project",
      property: "projectName"
    },
    {
      label: "Customer & Location",
      property: "contractContactNameAndPlace",
      cellComponent: AddressCell
    }
  ];

  if (type === "scheduled-deliveries") {
    columns.push({
      label: "Delivered",
      property: "actions",
      actions: [
        {
          label: "Yes",
          clickAction: proc => {
            let dispatchAction;
            proc.type = ProcurementStatuses.DELIVERED;
            dispatchAction = "getScheduledDeliveries";

            context.$store.dispatch("updateProcurement", {
              ...proc,
              delivered_at: $moment().format("YYYY-MM-DD hh:mm:ss"),
              dispatchAction
            });
          }
        },
        {
          label: "No",
          clickAction: proc => {
            context.$store.commit("setCreateEditComponentParams", {
              createEditComponent: DeliveryFailureForm,
              createEditComponentData: {
                procurement: proc
              },
              createEditComponentIsShown: true
            });
          }
        }
      ]
    });
  }
  return columns;
}

export function getOnHoldAndCancelledDeliveriesColumns() {
  return [
    {
      label: "PO #",
      property: "id"
    },
    {
      label: "Contract",
      property: "contractName"
    },
    {
      label: "Project",
      property: "projectName"
    },
    {
      label: "Customer & Location",
      property: "contractContactNameAndPlace",
      cellComponent: AddressCell
    },
    {
      label: "Notes",
      property: "noteText"
    }
  ];
}
